import React, { useCallback, useEffect, useReducer } from "react";

import Table from "./partials/Table";
import FilterForm from "./partials/FilterForm";
import Summary from "./partials/Summary";
import { useCookies } from "react-cookie";
import { getListReward } from "../../../controller/api/__loto__/reward";
import { calculatePage } from "../../../helper/helper";

export const Context = React.createContext(null);

const initialData = {
  filter: {
    from: new Date(),
    to: new Date(),
    phone: "",
    page: 0,
  },
  loading: true,
  data: {
    list: [],
    total: 0,
    totalPage: 0,
  },
  isPaying: false,
  filterPressCount: 0,
};

const reducer = (state, action) => {
  switch (action.type) {
    case "SUBMIT_FILTER":
      return {
        ...state,
        filter: {
          ...action.payload,
          page: 0,
        },
        loading: true,
        filterPressCount: state.filterPressCount + 1,
      };
    case "PAY_REWARD_ALL":
      return {
        ...state,
        isPaying: !state.isPaying,
      };
    case "UPDATE_DATA":
      return {
        ...state,
        loading: false,
        data: {
          ...action.payload,
        },
      };
    case "UPDATE_PAGE":
      return {
        ...state,
        loading: true,
        filter: {
          ...state.filter,
          page: action.payload,
        },
      };
    default:
      return {
        ...state,
      };
  }
};

export default () => {
  var [state, dispatch] = useReducer(reducer, initialData);

  const [cookies] = useCookies(["lottmekong"]);

  const getAllFunc = useCallback(async () => {
    let phone = state.filter.phone;

    const response = await getListReward(
      cookies.lottmekong,
      {
        from: state.filter.from,
        to: state.filter.to,
        phone: phone,
      },
      state.filter.page,
    );

    if (response) {
      dispatch({
        type: "UPDATE_DATA",
        payload: {
          list: response.data,
          total: response.total,
          totalPage: calculatePage(response.total),
        },
      });
    }
  }, [
    cookies.lottmekong,
    state.filter.from,
    state.filter.to,
    state.filter.page,
    state.filter.phone,
  ]);

  useEffect(() => {
    getAllFunc();
  }, [getAllFunc, state.filterPressCount, state.filter.page]);

  useEffect(() => {
    document.title = "Trúng thưởng Loto";
  }, []);

  return (
    <Context.Provider
      value={{
        state,
        dispatch,
      }}
    >
      <FilterForm />

      <br />

      <Summary />

      <br />

      <Table />
    </Context.Provider>
  );
};
